"use client";

import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from "react";
type Props = {
  icon: ReactNode;
  label: string;
  amount: string;
  count: string;
  isPlaceholder?: boolean;
  placeholderLabel?: string;
};
export default function KpiCard(t0) {
  const $ = _c(15);
  const {
    icon,
    label,
    amount,
    count,
    isPlaceholder: t1,
    placeholderLabel
  } = t0;
  const isPlaceholder = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== icon) {
    t2 = <div className="flex h-8 w-7 shrink-0 items-center justify-center text-gray-500 dark:text-white">{icon}</div>;
    $[0] = icon;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== label) {
    t3 = <p className="truncate text-sm text-gray-500 dark:text-white">{label}</p>;
    $[2] = label;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== amount || $[5] !== count || $[6] !== isPlaceholder || $[7] !== placeholderLabel) {
    t4 = isPlaceholder ? <p className="text-sm italic text-gray-400 dark:text-zinc-400">{placeholderLabel}</p> : <div className="flex items-baseline gap-2"><p className="text-lg font-semibold text-black dark:text-white">{amount} €</p><span className="text-xs text-gray-500 dark:text-zinc-300">{count}</span></div>;
    $[4] = amount;
    $[5] = count;
    $[6] = isPlaceholder;
    $[7] = placeholderLabel;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t3 || $[10] !== t4) {
    t5 = <div className="min-w-0">{t3}{t4}</div>;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t2 || $[13] !== t5) {
    t6 = <div className="flex flex-1 items-center gap-3 px-6 py-4">{t2}{t5}</div>;
    $[12] = t2;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
}